<template>
  <v-menu bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <chip-item icon="mdi-menu-down" :chip="chip" v-bind="attrs" v-on="on"/>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, idx) in chip.items"
        :key="idx"
        :to="item.route"
        :disabled="checkDisabled(item)"
      >
        <v-list-item-title class="body-2">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ChipItem from './ChipItem';

export default {
  components: {
    ChipItem,
  },
  props: {
    chip: {
      type: Object,
      required: true,
    },
  },
  methods: {
    checkPermission(routeObj) {
      const routePermissions = routeObj.route.meta.permissions;
      if (routePermissions) {
        const userPermissions = this.$root.user.permissions;
        return routePermissions.some(permission => userPermissions.includes(permission));
      }

      return true;
    },
    checkDisabled(item) {
      if (!item.route || !this.$router) return true;

      const routeObj = this.$router.resolve(item.route);
      return !this.checkPermission(routeObj);
    },
  },
};
</script>
